import { render } from "./ViewTaskListModal.vue?vue&type=template&id=6d4e27d9&scoped=true"
import script from "./ViewTaskListModal.vue?vue&type=script&lang=js"
export * from "./ViewTaskListModal.vue?vue&type=script&lang=js"

import "./ViewTaskListModal.vue?vue&type=style&index=0&id=6d4e27d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4e27d9"]])

export default __exports__